import React, { useState } from "react";
import "./FormFieldsStyle.css";

const InputField = (props) => {
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    let v = e?.target?.value;

    // let specialCharRegex = /[!@#$%^&*(),.?":;/'\\`~{}[\]|\-_=+<>]/;

    let value = v.trim();

    let specialCharRegex = /^[0-9a-zA-Z\/, ]*$/;
    if (value.length === 0) {
      props?.inputValue?.current?.setAttribute("disabled", true);
      setErrorMessage("");
    } else if (value.length > 0 && !specialCharRegex.test(value)) {
      props?.inputValue?.current?.setAttribute("disabled", true);
      setErrorMessage("Special characters not allowed");
    } else if (value.length > 74) {
      props?.inputValue?.current?.setAttribute("disabled", true);
      setErrorMessage("Maximum character limit is 74");
    } else {
      props?.inputValue?.current?.removeAttribute("disabled");
      setErrorMessage("");
    }

    localStorage.setItem(
      "inputValue",
      JSON.stringify({ key1: e.target.value })
    );
  };

  return (
    <div className="form-group">
      <label className="sel" style={{ fontSize: "16px", color: "#444444" }}>
        {props.item.text}
        <span className="asterisk-icon"></span>
      </label>
      <input
        type="text"
        className="form-control"
        disabled={props.disable}
        defaultValue={(props.userInputObj && props.userInputObj.key1) || ""}
        onInput={handleChange}
      />
      {errorMessage && (
        <div style={{ color: "red", paddingTop: "10px" }}>{errorMessage}</div>
      )}
      <span className="validate">&nbsp;</span>
    </div>
  );
};

export default InputField;
